import _ from 'lodash';
import React, { cloneElement, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TYPE } from '../../../../../../../constant';
import { loadAIDiagnosisQuestionAction, setAnsweringQuestionsAction } from '../../../../../../../redux/answeringQuestions/answeringQuestions';

function AiTestMultipleChoiceQuestion(props) {
  const dispatch = useDispatch();
  const answeringQuestions = useSelector(state => state.answeringQuestions);
  const loadAIDiagnosisQuestion = payload => { dispatch(loadAIDiagnosisQuestionAction(payload)) };
  const setAnsweringQuestions = payload => { dispatch(setAnsweringQuestionsAction(payload)) };

  const [questions, setQuestions] = useState(null);
  const [answerView, setAnswerView] = useState([]);
  const [answers, setAnswers] = useState([]);

  const handleQestionRandom = useCallback(() => {
    if (!answeringQuestions.data || answeringQuestions.data.objctYn === 'N') return;
    try {
      const { objctExmpCn = "", qstCransr = "" } = answeringQuestions.data;
      const objctExmpCns = objctExmpCn ? objctExmpCn.split(';') : [] // 보기문항
      const qstCransrs = qstCransr ? qstCransr.split(';') : []  // 정답문항

      let randomAnswers = objctExmpCns.concat(qstCransrs).sort(() => Math.random() - 0.5);

      if (answeringQuestions.randomMultipleAnswer && answeringQuestions.randomMultipleAnswer.length > 0) {
        randomAnswers = answeringQuestions.randomMultipleAnswer;
      } 

      setAnswerView(qstCransrs);
      // 문항을 합치고 랜덤돌림
      setQuestions(randomAnswers);
      setAnsweringQuestions({ randomMultipleAnswer: randomAnswers });

    } catch (error) {
      console.log({ error });
    }

  }, [answeringQuestions.data]);


  const handleChange = useCallback((e) => {
    let result = [...answers];
    const value = e.target.value;

    if (result.indexOf(value) > -1) {
      _.remove(result, (v) => v === value);
    } else {

      if (answerView.length === 1 && result.length >= 1) {
        result = [value];
      } else {
        result.push(value);
      }

    }
    props.onCount();
    setAnswers(result);
    setAnsweringQuestions({ 
      multipleAnswer: result.join(';')
      // answer: result,
    });
  }, [answers]);

  const onSubmit = useCallback(() => {
    setAnsweringQuestions({ randomMultipleAnswer: [], });
    if (answers.length === 0) {
      setAnsweringQuestions({ isShowNotEnteredAnswerPopup: true });
      return;
    };

    loadAIDiagnosisQuestion({ progressCode: TYPE.ANSWERING_QUESTIONS_PROGRESS.CONTINUE });

  }, [answeringQuestions, answerView, questions])

  return cloneElement(
    props.children || <React.Fragment />,
    {
      type: 'learning',
      questions: questions,
      answerView: answerView,
      answers: answers,
      answersQuestion: answeringQuestions.data,
      onSubmit: onSubmit,
      handleChange: handleChange,
      handleQestion: handleQestionRandom
    }
  )
}

export default AiTestMultipleChoiceQuestion;